module.exports = __webpack_public_path__ + "img/PR7.91263c6a.png";